import { useEffect, useRef } from "react";
import skyovalbackground from "../../../assets/images/skyovalbackground.png";
import skyovalbackgrounddesktopconnect from "../../../assets/images/skyovalbackgrounddesktopconnect.png";
import "./Connections.scss";
import * as $ from "jquery";

const CONNECTION_CONFIG = {
  mobile: { min: 0.2, max: 0.7 }, // Scroll range percentage for mobile (e.g., 20% to 70%)
  desktop: { min: 0.1, max: 0.8 }, // Scroll range percentage for desktop
};

const Connections = () => {
  const connection1 = useRef();
  const connection2 = useRef();
  const connection3 = useRef();
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      const scrollMinMax =
        window.innerWidth < 577
          ? CONNECTION_CONFIG.mobile
          : CONNECTION_CONFIG.desktop;

      // Dynamically calculate thresholds based on percentage
      const minThreshold = scrollMinMax.min * documentHeight;
      const maxThreshold = scrollMinMax.max * documentHeight;

      if (window.innerWidth < 577) {
        // Mobile Behavior
        if (scrollPosition >= minThreshold && scrollPosition <= maxThreshold) {
          connection1.current.style.opacity = "1";
        } else {
          connection1.current.style.opacity = "0";
        }
      } else {
        // Desktop Behavior
        const connectionsElement = document.getElementById(
          "connections-with-us"
        );
        if (!connectionsElement) return;

        if (scrollPosition >= minThreshold && scrollPosition <= maxThreshold) {
          connectionsElement.style.transform = "scale(1)";
        } else {
          connectionsElement.style.transform = "scale(0)";
        }
      }
    };

    // Attach event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="connections">
      <img
        className="skyovalbackground mobile"
        src={skyovalbackground}
        alt="skyovalbackground"
      />
      <img
        className="skyovalbackground desktop"
        src={skyovalbackgrounddesktopconnect}
        alt="skyovalbackgrounddesktopconnect"
      />
      <div className="container">
        <div className="title">
          Connect with <span>us!</span>
        </div>
        {/* <div id="connections-with-us" className="custom-col">
          <div className="custom-row" ref={connection1}>
            <div className="bullet-point">1.</div>
            <div className="custom-col">
              <div className="bullet-point-title">Michael Bankole</div>
              <div className="bullet-point-desc">
                Director, Ministry of Environment and Water Resources, Lagos
                State:
              </div>
              <div className="bullet-point-email">
                michael.bankole@lagosstate.gov.ng
              </div>
            </div>
          </div>
          <div className="custom-row" ref={connection2}>
            <div className="bullet-point">2.</div>
            <div className="custom-col">
              <div className="bullet-point-title">Wahab Adetokunbo</div>
              <div className="bullet-point-desc">
                Honourable Commissioner, Ministry of the Environment and Water
                Resources:
              </div>
              <div className="bullet-point-email">siju.fade2@gmail.com</div>
            </div>
          </div>
          <div className="custom-row" ref={connection3}>
            <div className="bullet-point">3.</div>
            <div className="custom-col">
              <div className="bullet-point-title">Gaji Omobolaji Tajudeen</div>
              <div className="bullet-point-desc">
                Permanent Secretary, Office of Environmental Services, Ministry
                of the Environment and Water Resources:
              </div>
              <div className="bullet-point-email">otgaji@gmail.com</div>
            </div>
          </div>
        </div> */}
        <div className="contact-us-text">
          For any inquiries or further assistance, please feel free to contact
          us via email at <a className="a-link">team@lcarp.ng</a>
        </div>
      </div>
    </div>
  );
};

export default Connections;
